import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { AppContainer } from "@egovernments/digit-ui-react-components";
import { Route, Switch, useRouteMatch } from "react-router-dom";
import { loginConfig } from "./config";
import LoginComponent from "./login";
import EmployeeLoginCard from "./emplogin";
import { Box, Card } from "@material-ui/core";

const EmployeeLogin = () => {
  const { t } = useTranslation();
  const { path } = useRouteMatch();

  const loginParams = useMemo(() =>
    loginConfig.map(
      (step) => {
        const texts = {};
        for (const key in step.texts) {
          texts[key] = t(step.texts[key]);
        }
        return { ...step, texts };
      },
      [loginConfig]
    )
  );

  return (
    <Switch>
      <Route path={`${path}`} exact>
        <Box>
          <EmployeeLoginCard />
        </Box>
      </Route>
    </Switch>
  );
};

export default EmployeeLogin;
